import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postContractor({ body }) {
  return BaseService.post(REST.CONTRACTORS, body);
}

function putContractor({ body, id }) {
  return BaseService.put(REST.CONTRACTORS_ID(id), body);
}

function getContractor(params) {
  return BaseService.get(REST.CONTRACTORS, {
    params: paramsFilter({ params }),
  });
}

function deleteContractor({ id }) {
  return BaseService.delete(REST.CONTRACTORS_ID(id));
}

export default {
  postContractor,
  putContractor,
  getContractor,
  deleteContractor,
};
